import React from 'react';
import styled from "styled-components";
import ButtonBase from "../../atoms/button.base";

const WelcomeMainSection = ({handleScrollToCities}) => {

    return (
        <Container className="position-relative d-block d-lg-flex align-items-center">
            <Background className="bg-gray100"/>

            <ContentCard className="container">
                <div className="row">
                    <div className="col-12 col-lg-5">
                        <h1 className="h1-bold">۲نبش، راهی سریع و مطمئن <br/> برای خانه‌دار شدن</h1>
                        <p className="mt-16 mt-lg-32 main-content-text">
                            <span>در ۲نبش بین صدها هزار آگهی ثبت‌شده جست‌وجو کنید،</span>
                            <span> به سرعت ملک مورد نظرتون رو پیدا کنید و برای انجام </span>
                            <span>  معامله‌ای مطمئن، با مشاورین املاک معتمد </span>
                            <span>و متخصص شهرتون در ارتباط باشید.</span>
                        </p>

                        <ButtonBase
                            color="secondary"
                            onClick={handleScrollToCities}
                            className="mt-32 mt-lg-40 main-content-button">
                            از اینجا شروع کنید
                        </ButtonBase>
                    </div>
                </div>
            </ContentCard>
        </Container>
    );
};

export default React.memo(WelcomeMainSection);

// styles

const Container = styled.div`
    min-height: 700px;
    height: 100vh;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        min-height: auto;
        height: auto;
    }
`;

const Background = styled.div`
    background-image: url("/_img/landings/welcome/main-d.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: absolute;
    width: 100%;
    height: 100%;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        position: relative;
        background-image: url("/_img/landings/welcome/main-m.jpg");
        height: 350px;
    }
`;

const ContentCard = styled.div`
    
    h1 {
        line-height: 1.67;
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        padding: 40px 24px 0;
        position: relative;
        top: -24px;
        border-radius: 24px 24px 0 0;
        background-color: #ffffff;
        
        .main-content-button {
            width: 100%;
        }
    }
`;